import { z } from 'zod'

export const sayHelloFormSchema = z.object({
  name: z.string().min(2),
  lastName: z.string().min(2),
  phoneNumber: z.string().min(5),
  email: z.string().email(),
  city: z.string().min(2),
  message: z.string().min(2),

  // Privacy consent fields
  privacyForRegistration: z.boolean().refine((val) => val === true, {
    message: 'You must accept the privacy policy for registration to proceed',
  }),
  privacyForMedicalBooking: z.boolean().refine((val) => val === true, {
    message: 'You must accept the privacy policy for medical booking to proceed',
  }),
  privacyForCommercialUse: z.boolean().default(false),
})

export type SayHelloFormData = z.infer<typeof sayHelloFormSchema>
